import { Navigate, Route, Routes } from 'react-router-dom'
import { BroadcastsRoutes } from 'entities/ExportRouters'
import { SMSBroadcasts } from 'pages/broadcasts/pages/broadcasts/oneTime/pages/SMSBroadcasts'
import { RinglessBroadcasts } from 'pages/broadcasts/pages/broadcasts/oneTime/pages/RinglessBroadcasts'

export const OneTimeRouter = () => {
  return (
    <Routes>
      <Route path={BroadcastsRoutes.sms} element={<SMSBroadcasts />} />
      <Route path={BroadcastsRoutes.ringless} element={<RinglessBroadcasts />} />
      <Route path={'*'} element={<Navigate to={BroadcastsRoutes.sms} />} />
    </Routes>
  )
}
